<template>
  <a-tooltip
    v-if="failureMessage"
    placement="top"
    color="var(--tooltip-bg)"
  >
    <template #title>
      <div class="flex flex-col gap-1">
        <span>{{ failureMessage }}</span>
        <span v-if="failedAtText" class="opacity-80">Failed on {{ failedAtText }}</span>
      </div>
    </template>
    <div class="w-fit cursor-help">
      <StatusTagProvider v-bind="$attrs" />
    </div>
  </a-tooltip>
  <StatusTagProvider v-else v-bind="$attrs" />
</template>

<script setup>
import { computed } from "vue";
import StatusTagProvider from "@/src/components/StatusTagProvider.vue";
import { getCampaignFailureMessage } from "@/src/constants/campaignInEngageConstants.js";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  failureReason: { type: String, default: "" },
  failedAt: { type: String, default: "" },
});

const failureMessage = computed(() => getCampaignFailureMessage(props.failureReason));

const failedAtText = computed(() => {
  if (!props.failedAt) return "";
  const date = new Date(props.failedAt);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
});
</script>
